import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bindAll } from '@bibliocommons/utils-react';
import { bibShape, shelfItemShape, userIdentityShape, ugcIOwnThisShape } from '@bibliocommons/bc-prop-types';
import ShelfActions from 'app/actions/ShelfActions';
import IOwnThisActions from 'app/actions/IOwnThisActions';
import ModalActions from 'app/actions/ModalActions';
import BibsActions from 'app/actions/BibsActions';
import { trackContentCollectionMove } from 'app/actions/AnalyticsGa4Actions';
import { selectBibEntities } from 'app/selectors/EntitiesSelector';
import { selectShelvesForCurrentUser, selectShelfTransactions } from 'app/selectors/ShelfSelector';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import { selectIOwnThisForCurrentUser } from 'app/selectors/ugc/IOwnThisSelector';
import ShelfActionsButton from './ShelfActionsButton';

export class ShelfActionsButtonContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  trackContentCollectionMove({ bibId, newShelf, privateItem }) {
    const properties = {
      content_collection_type: `shelf_${newShelf}`,
      privacy_status: privateItem ? 'private' : 'public'
    };
    this.props.trackContentCollectionMove({ bibId, properties });
  }

  render() {
    return <ShelfActionsButton {...this.props} trackContentCollectionMove={this.trackContentCollectionMove} />;
  }
}

ShelfActionsButtonContainer.propTypes = {
  metadataId: PropTypes.string.isRequired,
  block: PropTypes.bool,
  rounded: PropTypes.bool,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  reciprocalRank: PropTypes.number,
  bib: bibShape.isRequired,
  shelfItem: shelfItemShape,
  iOwnThis: ugcIOwnThisShape,
  user: userIdentityShape,
  shelfTransactions: ImmutablePropTypes.map,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  iOwnThisActions: PropTypes.objectOf(PropTypes.func).isRequired,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  iconOnly: PropTypes.bool,
  trackContentCollectionMove: PropTypes.func
};

const mapStateToProps = (state, ownProps) => {
  const shelfItem = selectShelvesForCurrentUser(state).get(ownProps.metadataId);
  const isFetching = state.getIn(['bibs', 'userTransactions', 'isFetching'], false);

  return {
    shelfItem,
    isLoading: ownProps.isLoading || isFetching,
    bib: selectBibEntities(state).get(ownProps.metadataId),
    shelfTransactions: selectShelfTransactions(state),
    user: selectCurrentUser(state),
    iOwnThis: selectIOwnThisForCurrentUser(state).get(ownProps.metadataId)
  };
};

const mapDispatchToProps = dispatch => ({
  shelfActions: bindActionCreators(ShelfActions, dispatch),
  iOwnThisActions: bindActionCreators(IOwnThisActions, dispatch),
  modalActions: bindActionCreators(ModalActions, dispatch),
  bibsActions: bindActionCreators(BibsActions, dispatch),
  trackContentCollectionMove: bindActionCreators(trackContentCollectionMove, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ShelfActionsButtonContainer);
